const PERMISSION = {
  DASHBOARD: 'DASHBOARD',
  DASHBOARD_FORM_SUB: 'DASHBOARD_FORM_SUB',
  DASHBOARD_VISITOR: 'DASHBOARD_VISITOR',
  DASHBOARD_ACCOUNT_REG: 'DASHBOARD_ACCOUNT_REG',
  DASHBOARD_ACCOUNT_BY_PRO: 'DASHBOARD_ACCOUNT_BY_PRO',
  DASHBOARD_TOTAL_AD: 'DASHBOARD_TOTAL_AD',

  DASHBOARD_READ: 'DASHBOARD_READ',
  DASHBOARD_LEADS: 'DASHBOARD_LEADS',
  DASHBOARD_JOBCARD: 'DASHBOARD_JOBCARD',
  PAGE_MANAGEMENT: 'PAGE_MANAGEMENT',
  USER: 'USER',
  USER_READ: 'USER_READ',
  USER_CREATE: 'USER_CREATE',
  USER_UPDATE: 'USER_UPDATE',
  USER_RESET_PASSWORD: 'USER_RESET_PASSWORD',
  USER_DELETE: 'USER_DELETE',
  ROLE: 'ROLE',
  ROLE_READ: 'ROLE_READ',
  ROLE_CREATE: 'ROLE_CREATE',
  ROLE_UPDATE: 'ROLE_UPDATE',
  ROLE_DELETE: 'ROLE_DELETE',
  LEADS: 'LEADS',
  LEADS_READ: 'LEADS_READ',
  LEADS_CREATE: 'LEADS_CREATE',
  LEADS_UPDATE: 'LEADS_UPDATE',
  LEADS_DELETE: 'LEADS_DELETE',
  LEADS_IMPORT: 'LEADS_IMPORT',
  LEADS_EXPORT: 'LEADS_EXPORT',
  LEADS_PRINT: 'LEADS_PRINT',
  LEADS_UPDATE_SERVICE_ADVISOR: 'LEADS_UPDATE_SERVICE_ADVISOR',
  LEADS_DOCUMENT: 'LEADS_DOCUMENT',
  LEADS_UPDATE_JC_STATUS: 'LEADS_UPDATE_JC_STATUS',
  JOBCARD_CREATE: 'JOBCARD_CREATE',
  JOBCARD_UPDATE: 'JOBCARD_UPDATE',
  JOBCARD_READ: 'JOBCARD_READ',
  JOBCARD_DELETE: 'JOBCARD_DELETE',
  JOBCARD_UPDATE_STATUS_QC: 'JOBCARD_UPDATE_STATUS_QC',
  JOBCARD_EXPORT: 'JOBCARD_EXPORT',
  JOBCARD_PRINT: 'JOBCARD_PRINT',
  JOBCARD_UPLOAD_DOC: 'JOBCARD_UPLOAD_DOC',
  JOBCARD_UPDATE_REMARK: 'UPDATE_REMARK',
  JOBCARD_UPDATE_STATUS: 'UPDATE_STATUS',
  CONFIGURATION: 'CONFIGURATION',
  SOURCES_READ: 'SOURCES_READ',
  SOURCES_CREATE: 'SOURCES_CREATE',
  SOURCES_UPDATE: 'SOURCES_UPDATE',
  SOURCES_DELETE: 'SOURCES_DELETE',
  SERVICE_TYPE_READ: 'SERVICE_TYPE_READ',
  SERVICE_TYPE_CREATE: 'SERVICE_TYPE_CREATE',
  SERVICE_TYPE_UPDATE: 'SERVICE_TYPE_UPDATE',
  SERVICE_TYPE_DELETE: 'SERVICE_TYPE_DELETE',
  POSITION_READ: 'POSITION_READ',
  POSITION_CREATE: 'POSITION_CREATE',
  POSITION_UPDATE: 'POSITION_UPDATE',
  POSITION_DELETE: 'POSITION_DELETE',
  BRAND_READ: 'BRAND_READ',
  BRAND_CREATE: 'BRAND_CREATE',
  BRAND_UPDATE: 'BRAND_UPDATE',
  BRAND_DELETE: 'BRAND_DELETE',
  MODEL_READ: 'MODEL_READ',
  MODEL_CREATE: 'MODEL_CREATE',
  MODEL_UPDATE: 'MODEL_UPDATE',
  MODEL_DELETE: 'MODEL_DELETE',
  COLOR_READ: 'COLOR_READ',
  COLOR_CREATE: 'COLOR_CREATE',
  COLOR_UPDATE: 'COLOR_UPDATE',
  COLOR_DELETE: 'COLOR_DELETE',
  TERM_CONDITIONS_READ: 'TERM_CONDITIONS_READ',
  TERM_CONDITIONS_CREATE: 'TERM_CONDITIONS_CREATE',
  TERM_CONDITIONS_UPDATE: 'TERM_CONDITIONS_UPDATE',
  TERM_CONDITIONS_DELETE: 'TERM_CONDITIONS_DELETE',
  QUOTATION_READ: 'QUOTATION_READ',
  QUOTATION_COUNTER_SALE_CREATE: 'QUOTATION_COUNTER_SALE_CREATE',
  QUOTATION_COUNTER_SALE_UPDATE: 'QUOTATION_COUNTER_SALE_UPDATE',
  QUOTATION_UPDATE: 'QUOTATION_UPDATE',
  QUOTATION_EXPORT: 'QUOTATION_EXPORT',
  QUOTATION_PRINT: 'QUOTATION_PRINT',
  QUOTATION_REMARK: 'QUOTATION_REMARK',
  INVOICE_READ: 'INVOICE_READ',
  INVOICE_GENERATE: 'INVOICE_GENERATE',
  INVOICE_QUOTATION: 'INVOICE_QUOTATION',
  INVOICE_DELETE: 'INVOICE_DELETE',
  INVOICE_PRINT: 'INVOICE_PRINT',
  INVOICE_EXPORT: 'INVOICE_EXPORT',
  PAYMENT_READ: 'PAYMENT_READ',
  PAYMENT_CREATE: 'PAYMENT_CREATE',
  PAYMENT_UPDATE: 'PAYMENT_UPDATE',
  PAYMENT_REMARK: 'PAYMENT_REMARK',
  PAYMENT_RECEIPT: 'PAYMENT_RECEIPT',
  PAYMENT_IMAGE: 'PAYMENT_IMAGE',
  PAYMENT_EXPORT: 'PAYMENT_EXPORT',
  GATEPASS_READ: 'GATEPASS_READ',
  GATEPASS_CREATE: 'GATEPASS_CREATE',
  GATEPASS_UPDATE: 'GATEPASS_UPDATE',
  GATEPASS_REMARK: 'GATEPASS_REMARK',
  GATEPASS_PRINT: 'GATEPASS_PRINT',
  GATEPASS_EXPORT: 'GATEPASS_EXPORT',
  // Inventory Permission
  CATEGORY_CREATE: 'CATEGORY_CREATE',
  CATEGORY_READ: 'CATEGORY_READ',
  CATEGORY_UPDATE: 'CATEGORY_UPDATE',
  CATEGORY_DELETE: 'CATEGORY_DELETE',
  SUBCATEGORY_CREATE: 'SUBCATEGORY_CREATE',
  SUBCATEGORY_READ: 'SUBCATEGORY_READ',
  SUBCATEGORY_UPDATE: 'SUBCATEGORY_UPDATE',
  SUBCATEGORY_DELETE: 'SUBCATEGORY_DELETE',
  SUPPLIER_CREATE: 'SUPPLIER_CREATE',
  SUPPLIER_READ: 'SUPPLIER_READ',
  SUPPLIER_UPDATE: 'SUPPLIER_UPDATE',
  SUPPLIER_DELETE: 'SUPPLIER_DELETE',
  SUPPLIER_EXPORT: 'SUPPLIER_EXPORT',
  PART_ITEMS_CREATE: 'PART_ITEMS_CREATE',
  PART_ITEMS_READ: 'PART_ITEMS_READ',
  PART_ITEMS_UPDATE: 'PART_ITEMS_UPDATE',
  PART_ITEMS_DELETE: 'PART_ITEMS_DELETE',
  STORAGE_CREATE: 'STORAGE_CREATE',
  STORAGE_READ: 'STORAGE_READ',
  STORAGE_UPDATE: 'STORAGE_UPDATE',
  STORAGE_DELETE: 'STORAGE_DELETE',
  PART_ITEMS_EXPORT: 'PART_ITEMS_EXPORT',
  PURCHASE_REQUESTED_CREATE: 'PURCHASE_REQUESTED_CREATE',
  PURCHASE_REQUESTED_READ: 'PURCHASE_REQUESTED_READ',
  PURCHASE_REQUESTED_UPDATE: 'PURCHASE_REQUESTED_UPDATE',
  PURCHASE_REQUESTED_DELETE: 'PURCHASE_REQUESTED_DELETE',
  PURCHASE_REQUESTED_PRINT: 'PURCHASE_REQUESTED_PRINT',
  PURCHASE_REQUESTED_EXPORT: 'PURCHASE_REQUESTED_EXPORT',
  PURCHASE_REQUESTED_REMARK: 'PURCHASE_REQUESTED_REMARK',
  PART_ITEMS_UPDATE_PRICE: 'PART_ITEMS_UPDATE_PRICE',
  PART_ISSUE_CREATE: 'PART_ISSUE_CREATE',
  PART_ISSUE_READ: 'PART_ISSUE_READ',
  PART_ISSUE_EXPORT: 'PART_ISSUE_EXPORT',
  PART_ISSUE_PRINT: 'PART_ISSUE_PRINT',
  PART_RETURN_CREATE: 'PART_RETURN_CREATE',
  PART_RETURN_READ: 'PART_RETURN_READ',
  PART_RETURN_UPDATE: 'PART_RETURN_UPDATE',
  PART_RETURN_EXPORT: 'PART_RETURN_EXPORT',
  PART_RETURN_PRINT: 'PART_RETURN_PRINT',
  STOCK_IN_CREATE: 'STOCK_IN_CREATE',
  STOCK_IN_READ: 'STOCK_IN_READ',
  STOCK_IN_UPDATE: 'STOCK_IN_UPDATE',
  STOCK_IN_DELETE: 'STOCK_IN_DELETE',
  STOCK_IN_EXPORT: 'STOCK_IN_EXPORT',
  STOCK_IN_PRINT: 'STOCK_IN_PRINT',
  STOCK_OUT_CREATE: 'STOCK_OUT_CREATE',
  STOCK_OUT_READ: 'STOCK_OUT_READ',
  STOCK_OUT_UPDATE: 'STOCK_OUT_UPDATE',
  STOCK_OUT_DELETE: 'STOCK_OUT_DELETE',
  STOCK_OUT_EXPORT: 'STOCK_OUT_EXPORT',
  STOCK_OUT_PRINT: 'STOCK_OUT_PRINT',
  SUPPLIER_RETURN_CREATE: 'SUPPLIER_RETURN_CREATE',
  SUPPLIER_RETURN_READ: 'SUPPLIER_RETURN_READ',
  SUPPLIER_RETURN_UPDATE: 'SUPPLIER_RETURN_UPDATE',
  SUPPLIER_RETURN_DELETE: 'SUPPLIER_RETURN_DELETE',
  SUPPLIER_RETURN_EXPORT: 'SUPPLIER_RETURN_EXPORT',
  SUPPLIER_RETURN_PRINT: 'SUPPLIER_RETURN_PRINT',
  PART_REMARK: 'PART_REMARK',
  LEAD_REMARK: 'LEAD_REMARK',
  PART_ISSUE_REMARK: 'PART_ISSUE_REMARK',
  STOCK_IN_REMARK: 'STOCK_IN_REMARK',
  PART_RETURN_REMARK: 'PART_RETURN_REMARK',
  SUPPLIER_RETURN_REMARK: 'SUPPLIER_RETURN_REMARK',
  SUPPLIER_REMARK: 'SUPPLIER_REMARK',
  CATEGORY_REMARK: 'CATEGORY_REMARK',
  STOCK_OUT_REMARK: 'STOCK_OUT_REMARK',
  STORAGE_REMARK: 'STORAGE_REMARK',
  PURCHASE_REQUEST_REMARK: 'PURCHASE_REQUEST_REMARK',
  DEFAULT: 'DEFAULT',
  LOGO_READ: 'LOGO_READ',
  BANNER: 'BANNER',
  BANNER_READ: 'BANNER_READ',
  BANNER_CREATE: 'BANNER_CREATE',
  BANNER: 'WIDGET',
  WIDGET_READ: 'WIDGET_READ',
  WIDGET_CREATE: 'WIDGET_CREATE',
  HOME_READ: 'HOME_READ',
  BHOME_UPDATE: 'BHOME_UPDATE',
  SELL_CAR_READ: 'SELL_CAR_READ',
  SELL_CAR_UPDATE: 'SELL_CAR_UPDATE',
  AFTER_SALES_SERVICES_READ: 'AFTER_SALES_SERVICES_READ',
  AFTER_SALES_SERVICES_UPDATE: 'AFTER_SALES_SERVICES_UPDATE',
  AUCTIION_READ: 'AUCTIION_READ',
  AUCTIION_UPDATE: 'AUCTIION_UPDATE',
  OUR_STORY_READ: 'OUR_STORY_READ',
  OUR_STORY_UPDATE: 'OUR_STORY_UPDATE',
  TERM_OF_USE_READ: 'TERM_OF_USE_READ',
  TERM_OF_USE_UPDATE: 'TERM_OF_USE_UPDATE',
  PRIVACY_POLICY_READ: 'PRIVACY_POLICY_READ',
  PRIVACY_POLICY_UPDATE: 'PRIVACY_POLICY_UPDATE',
  SLIDER_MANAGEMENT_READ: 'SLIDER_MANAGEMENT_READ',
  SLIDER_MANAGEMENT_DELETE: 'SLIDER_MANAGEMENT_DELETE',
  SLIDER_MANAGEMENT_CREATE: 'SLIDER_MANAGEMENT_CREATE',
  SLIDER_MANAGEMENT_UPDATE: 'SLIDER_MANAGEMENT_UPDATE',
  PROMOTION_READ: 'PROMOTION_READ',
  PROMOTION_CREATE: 'PROMOTION_CREATE',
  CAR_MANAGEMENT_UPDATE: 'CAR_MANAGEMENT_UPDATE',
  CAR_MANAGEMENT_READ: 'CAR_MANAGEMENT_READ',
  CAR_MANAGEMENT_DELETE: 'CAR_MANAGEMENT_DELETE',
  CAR_MANAGEMENT_CREATE: 'CAR_MANAGEMENT_CREATE',
  BUY_CAR_READ: 'BUY_CAR_READ',
  BUY_CAR_UPDATE: 'BUY_CAR_UPDATE',
  BUY_CAR_REMARK: 'BUY_CAR_REMARK',
  BUY_CAR_VIEW: 'BUY_CAR_VIEW',
  SELL_CAR_READ: 'SELL_CAR_READ',
  SELL_CAR_UPDATE: 'SELL_CAR_UPDATE',
  SELL_CAR_REMARK: 'SELL_CAR_REMARK',
  SERVICE_UPDATE: 'SERVICE_UPDATE',
  SERVICE_REMARK: 'SERVICE_REMARK',
  SERVICE_READ: 'SERVICE_READ',
  CUSTOMER_REVIEW_READ: 'CUSTOMER_REVIEW_READ',
  CUSTOMER_REVIEW_UPDATE: 'CUSTOMER_REVIEW_UPDATE',
  CUSTOMER_REVIEW_DELETE: 'CUSTOMER_REVIEW_DELETE',
  CUSTOMER_REVIEW_CREATE: 'CUSTOMER_REVIEW_CREATE',
  NEW_UPDATE: 'NEW_UPDATE',
  NEW_READ: 'NEW_READ',
  NEW_DELETE: 'NEW_DELETE',
  NEW_CREATE: 'NEW_CREATE',
  NEW_PROMOTION_CREATE: 'NEW_PROMOTION_CREATE',
  NEW_PROMOTION_READ: 'NEW_PROMOTION_READ',
  AUTHOR_DELETE: 'AUTHOR_DELETE',
  AUTHOR_UPDATE: 'AUTHOR_UPDATE',
  AUTHOR_CREATE: 'AUTHOR_CREATE',
  AUTHOR_READ: 'AUTHOR_READ',
  CUSTOMER_READ: 'CUSTOMER_READ',
  CAREER_CREATE: 'CAREER_CREATE',
  CAREER_DELETE: 'CAREER_DELETE',
  CAREER_UPDATE: 'CAREER_UPDATE',
  CAREER_READ: 'CAREER_READ',
  HOW_TO_APPLY_CREATE: 'HOW_TO_APPLY_CREATE',
  HOW_TO_APPLY_READ: 'HOW_TO_APPLY_READ',
  FAQ_UPDATE: 'FAQ_UPDATE',
  FAQ_CREATE: 'FAQ_CREATE',
  FAQ_DELETE: 'FAQ_DELETE',
  FAQ_READ: 'FAQ_READ',
  BODY_TYPE_READ: 'BODY_TYPE_READ',
  BODY_TYPE_DELETE: 'BODY_TYPE_DELETE',
  BODY_TYPE_CREATE: 'BODY_TYPE_CREATE',
  BODY_TYPE_UPDATE: 'BODY_TYPE_UPDATE',
  YEAR_READ: 'YEAR_READ',
  YEAR_CREATE: 'YEAR_CREATE',
  YEAR_DELETE: 'YEAR_DELETE',
  YEAR_UPDATE: 'YEAR_UPDATE',
  CONDITION_DELETE: 'CONDITION_DELETE',
  CONDITION_READ: 'CONDITION_READ',
  CONDITION_UPDATE: 'CONDITION_UPDATE',
  CONDITION_CREATE: 'CONDITION_CREATE',
  FULE_TYPE_READ: 'FULE_TYPE_READ',
  FULE_TYPE_CREATE: 'FULE_TYPE_CREATE',
  FULE_TYPE_DELETE: 'FULE_TYPE_DELETE',
  FULE_TYPE_UPDATE: 'FULE_TYPE_UPDATE',
  TRANSMISSION_DELETE: 'TRANSMISSION_DELETE',
  TRANSMISSION_CREATE: 'TRANSMISSION_CREATE',
  TRANSMISSION_UPDATE: 'TRANSMISSION_UPDATE',
  TRANSMISSION_READ: 'TRANSMISSION_READ',
  DEPARTMENT_CREATE: 'DEPARTMENT_CREATE',
  DEPARTMENT_DELETE: 'DEPARTMENT_DELETE',
  DEPARTMENT_READ: 'DEPARTMENT_READ',
  DEPARTMENT_UPDATE: 'DEPARTMENT_UPDATE',
  FAQ_TYPE_DELETE: 'FAQ_TYPE_DELETE',
  FAQ_TYPE_CREATE: 'FAQ_TYPE_CREATE',
  FAQ_TYPE_READ: 'FAQ_TYPE_READ',
  FAQ_TYPE_UPDATE: 'FAQ_TYPE_UPDATE',
  SELLER_TYPE_CREATE: 'SELLER_TYPE_CREATE',
  SELLER_TYPE_UPDATE: 'SELLER_TYPE_UPDATE',
  SELLER_TYPE_DELETE: 'SELLER_TYPE_DELETE',
  SELLER_TYPE_READ: 'SELLER_TYPE_READ',
  INBOX_SELL_CAR_UPDATE: 'INBOX_SELL_CAR_UPDATE',
  INBOX_SELL_CAR_REMARK: 'INBOX_SELL_CAR_REMARK',
  INBOX_SELL_CAR_READ: 'INBOX_SELL_CAR_READ',

  APP_MENU_READ: 'APP_MENU_READ',
  APP_MENU_CREATE: 'APP_MENU_CREATE',
  APP_MENU_UPDATE: 'APP_MENU_UPDATE',
  APP_MENU_DELETE: 'APP_MENU_DELETE',
};

const IS_PERMISSION = {
  DASHBOARD_READ: true,
  USER_READ: true,
  USER_CREATE: true,
  USER_UPDATE: true,
  USER_RESET_PASSWORD: true,
  ROLE_READ: true,
  ROLE_CREATE: true,
  ROLE_UPDATE: true,
  ROLE_DELETE: true,
  LEADS_READ: true,
  LEADS_CREATE: true,
  LEADS_UPDATE: true,
  LEADS_DELETE: true,
  LEADS_IMPORT: true,
  LEADS_EXPORT: true,
  LEADS_PRINT: true,
  LEADS_DOCUMENT: true,
  LEADS_UPDATE_JC_STATUS: true,
  SOURCES_READ: true,
  SOURCES_CREATE: true,
  SOURCES_UPDATE: true,
  SOURCES_DELETE: true,
  SERVICE_TYPE_READ: true,
  SERVICE_TYPE_CREATE: true,
  SERVICE_TYPE_UPDATE: true,
  SERVICE_TYPE_DELETE: true,
  POSITION_READ: true,
  POSITION_CREATE: true,
  POSITION_UPDATE: true,
  POSITION_DELETE: true,
  BRAND_CREATE: false,
  BRAND_DELETE: false,
  BRAND_READ: false,
  BRAND_UPDATE: false,
  MODEL_READ: true,
  MODEL_CREATE: true,
  MODEL_UPDATE: true,
  MODEL_DELETE: true,
  COLOR_READ: true,
  COLOR_CREATE: true,
  COLOR_UPDATE: true,
  COLOR_DELETE: true,
  TERM_CONDITIONS_READ: true,
  TERM_CONDITIONS_CREATE: true,
  TERM_CONDITIONS_UPDATE: true,
  TERM_CONDITIONS_DELETE: true,
  JOBCARD_CREATE: true,
  OBCARD_UPDATE: true,
  JOBCARD_READ: true,
  JOBCARD_DELETE: true,
  JOBCARD_UPDATE_STATUS_QC: true,
  JOBCARD_EXPORT: true,
  JOBCARD_PRINT: true,
  JOBCARD_UPLOAD_DOC: true,
  CATEGORY_CREATE: true,
  CATEGORY_READ: true,
  CATEGORY_UPDATE: true,
  CATEGORY_DELETE: true,
  SUBCATEGORY_CREATE: true,
  SUBCATEGORY_READ: true,
  SUBCATEGORY_UPDATE: true,
  SUBCATEGORY_DELETE: true,
  SUPPLIER_CREATE: true,
  SUPPLIER_READ: true,
  SUPPLIER_UPDATE: true,
  SUPPLIER_DELETE: true,
  PART_ITEMS_CREATE: true,
  PART_ITEMS_READ: true,
  PART_ITEMS_UPDATE: true,
  PART_ITEMS_DELETE: true,
  STORAGE_CREATE: true,
  STORAGE_READ: true,
  STORAGE_UPDATE: true,
  STORAGE_DELETE: true,
  PART_ITEMS_PRINT: true,
  PART_ITEMS_EXPORT: true,
  PURCHASE_REQUESTED_CREATE: true,
  PURCHASE_REQUESTED_READ: true,
  PURCHASE_REQUESTED_UPDATE: true,
  PURCHASE_REQUESTED_DELETE: true,
  PURCHASE_REQUESTED_PRINT: true,
  PURCHASE_REQUESTED_EXPORT: true,
  PART_ITEMS_UPDATE_PRICE: true,
  PART_ISSUE_CREATE: true,
  PART_ISSUE_READ: true,
  PART_ISSUE_EXPORT: true,
  PART_ISSUE_PRINT: true,
  PART_RETURN_CREATE: true,
  PART_RETURN_READ: true,
  PART_RETURN_UPDATE: true,
  PART_RETURN_EXPORT: true,
  PART_RETURN_PRINT: true,
  STOCK_IN_CREATE: true,
  STOCK_IN_READ: true,
  STOCK_IN_UPDATE: true,
  STOCK_IN_DELETE: true,
  STOCK_IN_EXPORT: true,
  STOCK_IN_PRINT: true,
  STOCK_OUT_CREATE: true,
  STOCK_OUT_READ: true,
  STOCK_OUT_UPDATE: true,
  STOCK_OUT_DELETE: true,
  STOCK_OUT_EXPORT: true,
  STOCK_OUT_PRINT: true,
  SUPPLIER_RETURN_CREATE: true,
  SUPPLIER_RETURN_READ: true,
  SUPPLIER_RETURN_UPDATE: true,
  SUPPLIER_RETURN_DELETE: true,
  SUPPLIER_RETURN_EXPORT: true,
  SUPPLIER_RETURN_PRINT: true,
  DEFAULT: true,
  LOGO_READ: true,
  BANNER_READ: true,
  BANNER_CREATE: true,
};

const MODULE_NAME = {
  DASHBOARD: 'DASHBOARD',
  USER: 'USER',
  ROLE: 'ROLE',
  JOBCARD: 'JOBCARD',
  LEADS: 'LEADS',
  CONFIGURATION: 'CONFIGURATION',
  INVENTORY: 'INVENTORIES',
};

export const PARENT_MODULE = {
  [MODULE_NAME.INVENTORY]: [
    PERMISSION.CATEGORY_CREATE,
    PERMISSION.CATEGORY_READ,
    PERMISSION.CATEGORY_UPDATE,
    PERMISSION.CATEGORY_DELETE,
    PERMISSION.SUBCATEGORY_CREATE,
    PERMISSION.SUBCATEGORY_READ,
    PERMISSION.SUBCATEGORY_UPDATE,
    PERMISSION.SUBCATEGORY_DELETE,
    PERMISSION.SUPPLIER_CREATE,
    PERMISSION.SUPPLIER_READ,
    PERMISSION.SUPPLIER_UPDATE,
    PERMISSION.SUPPLIER_DELETE,
    PERMISSION.PART_ITEMS_CREATE,
    PERMISSION.PART_ITEMS_READ,
    PERMISSION.PART_ITEMS_UPDATE,
    PERMISSION.PART_ITEMS_DELETE,
    PERMISSION.STORAGE_CREATE,
    PERMISSION.STORAGE_READ,
    PERMISSION.STORAGE_UPDATE,
    PERMISSION.STORAGE_DELETE,
    PERMISSION.PART_ITEMS_EXPORT,
    PERMISSION.PURCHASE_REQUESTED_CREATE,
    PERMISSION.PURCHASE_REQUESTED_READ,
    PERMISSION.PURCHASE_REQUESTED_UPDATE,
    PERMISSION.PURCHASE_REQUESTED_DELETE,
    PERMISSION.PURCHASE_REQUESTED_PRINT,
    PERMISSION.PURCHASE_REQUESTED_EXPORT,
    PERMISSION.PART_ITEMS_UPDATE_PRICE,
    PERMISSION.PART_ISSUE_CREATE,
    PERMISSION.PART_ISSUE_READ,
    PERMISSION.PART_ISSUE_EXPORT,
    PERMISSION.PART_ISSUE_PRINT,
    PERMISSION.PART_RETURN_CREATE,
    PERMISSION.PART_RETURN_READ,
    PERMISSION.PART_RETURN_UPDATE,
    PERMISSION.PART_RETURN_EXPORT,
    PERMISSION.PART_RETURN_PRINT,
    PERMISSION.STOCK_IN_CREATE,
    PERMISSION.STOCK_IN_READ,
    PERMISSION.STOCK_IN_UPDATE,
    PERMISSION.STOCK_IN_DELETE,
    PERMISSION.STOCK_IN_EXPORT,
    PERMISSION.STOCK_IN_PRINT,
    PERMISSION.STOCK_OUT_CREATE,
    PERMISSION.STOCK_OUT_READ,
    PERMISSION.STOCK_OUT_UPDATE,
    PERMISSION.STOCK_OUT_DELETE,
    PERMISSION.STOCK_OUT_EXPORT,
    PERMISSION.STOCK_OUT_PRINT,
    PERMISSION.SUPPLIER_RETURN_CREATE,
    PERMISSION.SUPPLIER_RETURN_READ,
    PERMISSION.SUPPLIER_RETURN_UPDATE,
    PERMISSION.SUPPLIER_RETURN_DELETE,
    PERMISSION.SUPPLIER_RETURN_EXPORT,
    PERMISSION.SUPPLIER_RETURN_PRINT,
  ],
  [MODULE_NAME.USER]: [PERMISSION.USER, PERMISSION.USER_READ, PERMISSION.USER_CREATE, PERMISSION.USER_UPDATE, PERMISSION.USER_RESET_PASSWORD],
  [MODULE_NAME.CONFIGURATION]: [
    PERMISSION.SOURCES_READ,
    PERMISSION.SOURCES_CREATE,
    PERMISSION.SOURCES_UPDATE,
    PERMISSION.SOURCES_DELETE,
    PERMISSION.SERVICE_TYPE_READ,
    PERMISSION.SERVICE_TYPE_CREATE,
    PERMISSION.SERVICE_TYPE_UPDATE,
    PERMISSION.SERVICE_TYPE_DELETE,
    PERMISSION.POSITION_READ,
    PERMISSION.POSITION_CREATE,
    PERMISSION.POSITION_UPDATE,
    PERMISSION.POSITION_DELETE,
    PERMISSION.BRAND_READ,
    PERMISSION.BRAND_CREATE,
    PERMISSION.BRAND_UPDATE,
    PERMISSION.BRAND_DELETE,
    PERMISSION.MODEL_READ,
    PERMISSION.MODEL_CREATE,
    PERMISSION.MODEL_UPDATE,
    PERMISSION.MODEL_DELETE,
    PERMISSION.COLOR_READ,
    PERMISSION.COLOR_CREATE,
    PERMISSION.COLOR_UPDATE,
    PERMISSION.COLOR_DELETE,
    PERMISSION.TERM_CONDITIONS_READ,
    PERMISSION.TERM_CONDITIONS_CREATE,
    PERMISSION.TERM_CONDITIONS_UPDATE,
    PERMISSION.TERM_CONDITIONS_DELETE,
  ],
};

export const ROLE_USER = {
  SUPER_ADMIN: 'SUPER_ADMIN',
};
export { IS_PERMISSION, MODULE_NAME, PERMISSION };
